import QueryService from "../utils/QueryService.ts";

class ImagesService {
	queryService = new QueryService("/images/");
	imageModificationQueryService = new QueryService("/image_modifications/");

	increaseResolution = async (
		imageUrl: string,
		resolution: number,
		content_moderation: boolean = false,
	): Promise<any> => {
		const response = await this.imageModificationQueryService.post("image/increase_resolution_old", {
			imageUrl: imageUrl,
			desired_increase: resolution,
			content_moderation: content_moderation,
		});
		const result = response[0];
		return result.result_url;
	};
}

export default ImagesService;
